import React, { useState, useRef, useEffect } from "react";
import "../QueryOutputNavbar/QueryOutputNavbar.scss";
import { Tooltip } from "@mui/material";
import { LuMinimize2, LuMaximize2 } from "react-icons/lu";
import { BiDownload } from "react-icons/bi";
import { 
  MdFirstPage, 
  MdLastPage, 
  MdNavigateBefore, 
  MdNavigateNext 
} from "react-icons/md";

function QueryOutputNavbar({
  onTabChange,
  activeTab,
  onExport,
  onMaximize,
  resourceId,
  systemUserId,
  // Pagination props
  currentPage,
  totalPages,
  itemsPerPage,
  totalItems,
  onPageChange,
  onItemsPerPageChange,
  showPagination = false,
}) {
  const [isMaximized, setIsMaximized] = useState(false);

  const handleMaximize = () => {
    setIsMaximized(!isMaximized);
    onMaximize();
  };

  const handleExport = () => {
    if (onExport) {
      onExport();
    }
  };

  return (
    <div className="database-gui-query-output-navbar-container">
      <div className="database-gui-query-output-navbar-section">
        <div className="database-gui-query-output-navbar-section-left">
          <div className="database-gui-query-output-navbar-section-left1">
            <button
              className={`database-gui-navbar-button-left ${
                activeTab === "Data Output" ? "active" : ""
              }`}
              onClick={() => onTabChange("Data Output")}
            >
              Data Output
            </button>
          </div>
          <div className="database-gui-query-output-navbar-section-left2">
            <button
              className={`database-gui-navbar-button-left ${
                activeTab === "Message" ? "active" : ""
              }`}
              onClick={() => onTabChange("Message")}
            >
              Message
            </button>
          </div>
        </div>
        <div className="database-gui-query-output-navbar-section-right">
          {/* Pagination Controls */}
          {showPagination && (
            <div className="database-gui-pagination-controls-navbar">
              <div className="database-gui-pagination-info">
                <span className="database-gui-page-info-text">
                  Showing {(currentPage - 1) * itemsPerPage + 1} -{" "}
                  {Math.min(currentPage * itemsPerPage, totalItems)} of{" "}
                  {totalItems}
                </span>
              </div>
              
              <div className="database-gui-pagination-arrows-navbar">
                <Tooltip title="First page">
                  <button
                    onClick={() => onPageChange(1)}
                    disabled={currentPage === 1}
                    className="database-gui-pagination-button"
                  >
                    <MdFirstPage size={18} />
                  </button>
                </Tooltip>
                <Tooltip title="Previous page">
                  <button
                    onClick={() => onPageChange(currentPage - 1)}
                    disabled={currentPage === 1}
                    className="database-gui-pagination-button"
                  >
                    <MdNavigateBefore size={18} />
                  </button>
                </Tooltip>
                <Tooltip title="Next page">
                  <button
                    onClick={() => onPageChange(currentPage + 1)}
                    disabled={currentPage === totalPages}
                    className="database-gui-pagination-button"
                  >
                    <MdNavigateNext size={18} />
                  </button>
                </Tooltip>
                <Tooltip title="Last page">
                  <button
                    onClick={() => onPageChange(totalPages)}
                    disabled={currentPage === totalPages}
                    className="database-gui-pagination-button"
                  >
                    <MdLastPage size={18} />
                  </button>
                </Tooltip>
              </div>
            </div>
          )}

          <div className="database-gui-dropdown-container">
            <Tooltip title="Save results to file">
              <button className="database-gui-navbar-button-right" onClick={handleExport}>
                <BiDownload size={20} />
              </button>
            </Tooltip>
          </div>

          <button
            className="database-gui-maximizeminimizebutton-icon"
            onClick={handleMaximize}
          >
            {isMaximized ? (
              <LuMinimize2 size={20} />
            ) : (
              <LuMaximize2 size={20} />
            )}
          </button>
        </div>
      </div>
    </div>
  );
}

export default QueryOutputNavbar;
